import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useStoredArray } from "../../../state/InternalContext";

interface StoredArrayProps {
    store: string,
}

/***
 * Array source that returns the children of a stored array.
 */
export const StoredArray = React.memo(function StoredArray({ store }: StoredArrayProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const storedArray = useStoredArray(store);

    useEffect(() => {
        setArray(storedArray || []);
    }, [storedArray, setArray]);

    return <></>;
});